import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../Button/Button";
import Input from "../Input/Input";
import AddAutoLRtable from "./AddAutoLRtable";
import "./LRTable.scss";

const LRTable = ({
  onAdd,
  AddLr_from_Input = () => {},
  showAutoLRButton = true,
  data,
  formkey,
  TypeOfPortal,
  SelectedData = [],
}: any) => {
  const [LR, setLR] = useState<string>("");
  const [notFound, setNotFound] = useState<boolean>(false);
  const [AutoLR, setAutoLR] = useState(false);
  const { fielddataa } = useSelector((store: any) => store.FormFieldData);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setLR(e.target.value);
  };

  const handleAddClick = () => {
    // const result = data?.find((item) => item.LR_No.toLowerCase() === LR);
    if (LR) {
      const result = data?.find((item) => item.LR_No === LR || item.LR_No.toLowerCase() === LR.toLowerCase());
      if (result) {
        AddLr_from_Input(result);
        setLR(""); // Reset input
      }
    }
  };

  const handleAddAutoLR = () => {
    setAutoLR(true);
  };

  return (
    <div>
      <div className={formkey !== "Sales_Return" ? "memoinput" : ""}>
        {formkey !== "Sales_Return" && (
          <div className="memoinputdiv">
            <Input
              EMTQuery=""
              checked={""}
              InputConfig={{ AllCaps: true }}
              TypeOfPortal={""}
              name={"Enter_LR_No"}
              handleInputChange={handleInputChange}
              type="text"
              modalform={true}
              Section_Type={""}
              value={LR}
              className={"Memoinput1"}
              touched={""}
              error={""}
              handleBlur={() => {}}
              label={"Enter LR No"}
              max={Infinity}
              JurnalDropdown={""}
              disabled={""}
              transactions={""}
              PaymentProcess={""}
              notSearchable={""}
            />
          </div>
        )}

        <div className="memoinputdiv1">
          {formkey !== "Sales_Return" && (
            <Button
              name="Addlrbutton"
              text="ADD CN"
              action={handleAddClick}
              type={""}
              children={""}
              disabled={""}
            ></Button>
          )}

          {showAutoLRButton && (
            <Button
              name="AddlrAutoButton"
              text={formkey === "Sales_Return" ? "GET BILLS" : "SELECT CN"}
              action={handleAddAutoLR}
              type={""}
              children={""}
              disabled={""}
            ></Button>
          )}
        </div>
      </div>
      {notFound && <p>LR number not found!</p>}
      {AutoLR ? (
        <>
          <AddAutoLRtable
            setAutoLR={() => setAutoLR(false)}
            show={AutoLR}
            TypeOfPortal={TypeOfPortal}
            fielddata={fielddataa}
            data={data}
            addLR={(val) => onAdd(val)}
            parentID={Math.random() * 10}
            SelectedData={SelectedData}
            formkey={formkey}
          />
        </>
      ) : null}
    </div>
  );
};

export default LRTable;
